import { useEffect, useRef } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Hammer } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      toast.error("Missing session — please try again.");
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    const role = params.get("role");

    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id, role });
        localStorage.setItem("dh_token", data.access_token);
        setUser(data.user);
        // Clear hash
        window.history.replaceState({}, "", "/feed");
        toast.success(`Welcome, ${data.user.name}!`);
        navigate("/feed", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, params, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-slate-600">
        <div className="w-12 h-12 rounded-xl bg-[#3E2A4E] text-[#D9FF3D] grid place-items-center animate-pulse">
          <Hammer size={22} />
        </div>
        <div className="font-semibold">Signing you in…</div>
      </div>
    </div>
  );
}
